export const EXTERNAL_LINKS = {
  TERMS_OF_SERVICE: "https://sharpperformance.com/terms-of-service",
  PRIVACY_POLICY: "https://sharpperformance.com/privacy",
};
